export default "__VITE_ASSET__Cg0XRal2__"